import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Section = tw.section`w-full flex flex-col items-center justify-center py-12 bg-white`;
const Heading = styled.h1`
  font-family: 'Urbanist', sans-serif;
  font-size: 40px;
  font-weight: semi-bolf;
  text-align: center;
  margin-bottom: 1.5rem;
  color: #4e7662;
  line-height: 1.2;
`;
const Paragraph = styled.p`
  font-family: 'Urbanist', sans-serif;
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  max-width: 40rem;
  margin-left: auto;
  margin-right: auto;
  color: #7E7E7E;
  line-height: 1.6;
`;
const WelcomeSection = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <Heading>{t("welcome.heading")}</Heading>
      <Paragraph>{t("welcome.paragraph")}</Paragraph>
    </Section>
  );
};

export default WelcomeSection;
